import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const DisableUpdatesIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg} focusable="false">
      <path d="M1600 1152q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zM512 768H0V256h128v275q67-122 163-220t213-168T752 37t272-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 39-3 78t-10 77q-26-27-56-51t-62-45q1-15 2-29t1-30q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-129 0-250 36T547 267 358 428 218 640h294v128zm571 1149q20 32 44 62t52 56q-38 6-77 9t-78 4q-114 0-223-25t-209-71-187-114-159-150-124-182-84-209l123-34q40 145 123 265t198 208 253 135 289 49q15 0 29-1t30-2z" />
    </svg>
  ),
  displayName: 'DisableUpdatesIcon',
});

export default DisableUpdatesIcon;
